/**
 * @author: subhasish.ghosh@zoom.us
 */

import React from "react";
import { Box, CircularProgress } from "@mui/material";
import "./styles.css";
import { ZOOM_LOGO } from "@utils/constants";

const Landing = () => {
  return (
    <Box
      className="landing-container"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#fff",
        textAlign: "center",
        gap: "35px",
        position: "relative",
      }}
    >
      <img src={ZOOM_LOGO} alt="Zoom Logo" className="nav-logo" />
      <div className="loader-container" style={{ height: "5vh" }}>
        <CircularProgress size="3rem" />
      </div>
    </Box>
  );
};

export default Landing;
